module.exports = __webpack_public_path__ + "media/images/landing/icon-design-process-a13087f4fc512aeca790809bf0217baf.svg";